import { render, staticRenderFns } from "./OfferDetail.vue?vue&type=template&id=4f6c2e6c&scoped=true&"
import script from "./OfferDetail.vue?vue&type=script&lang=ts&"
export * from "./OfferDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OfferDetail.vue?vue&type=style&index=0&id=4f6c2e6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c2e6c",
  null
  
)

export default component.exports